// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_oe-5";
export var filledCircle = "_oe-4";
export var historyEntry = "_oe-3";
export var messageSideLeft = "_oe-1";
export var messageSideRight = "_oe-2";
export var orderTrackingCarouselWrapper = "_oe-6";
export var orderTrackingInfoContainer = "_oe-0";